<template>
  <div class="">
    <Select v-model="min" style="width:120px">
      <Option v-for="item in leftData" :value="item.key" :key="item.key" :disabled="item.disabled">{{ item.label }}</Option>
    </Select>
    <span> — </span>
    <Select v-model="max" style="width:120px">
      <Option v-for="item in rightData" :value="item.key" :key="item.key" :disabled="item.disabled">{{ item.label }}</Option>
    </Select>
  </div>
</template>
<script>
import { deepCopy } from '@/common/js/utils'
import { ages } from '@/data/baidu/ad_target_data'
export default {
  name: 'TencentAge',
  props: {
    value: {
      type: Array
    },
    offset: {
      type: Number,
      default: 1
    }
  },
  computed: {
    min: {
      get () {
        const [min] = this.value
        return min
      },
      set (val) {
        this.$emit('input', [val, this.max])
      }
    },
    max: {
      get () {
        const [, max] = this.value
        return max
      },
      set (val) {
        this.$emit('input', [this.min, val])
      }
    },
    leftData () {
      const mapAge = deepCopy(ages).map(ret => {
        ret.disabled = ret.key >= this.max - (this.offset - 1)
        return ret
      })
      return mapAge
    },
    rightData () {
      const copy = deepCopy(ages)
      for (let o = 0; o < this.offset; o++) copy.shift()
      const mapAge = copy.map(ret => {
        ret.disabled = ret.key <= this.min + (this.offset - 1)
        return ret
      })
      return mapAge
    }
  }
}
</script>
